import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  mainPaper: {
    flex: 1,
    maxHeight: 300,
    maxWidth: 500,
    padding: theme.spacing(1),
    overflowY: 'scroll',
    ...theme.scrollbarStyles
  },

  listChat: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '0px'
  },

  listItemChat: {
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_50.main,
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? theme.palette.dark_400.main : theme.palette.blue_50.main
    }
  },

  messageContactName: {
    display: 'flex',
    gap: '8px',
    color: theme.palette.blue_300.main,
    fontWeight: '500',
    '& svg': {
      color: theme.palette.blue_300.main
    }
  },

  messageDate: {
    display: 'flex',
    justifyContent: 'flex-end',
    fontSize: '0.75rem',
    color: theme.palette.gray_400.main
  }
}))
